import React, { PropTypes } from "react";
import { DragLayer } from "react-dnd";
import MenuItem from "../menu/menuItem.react";
import Component from "react-pure-render/component";

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  height: "100%"
};

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: "none"
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

class CustomDragLayer extends Component {
  render() {
    const { item, itemType, isDragging, children, wrapperWidth } = this.props;
    if (!isDragging) {
      return null;
    }

    const width = wrapperWidth + "px";
    return (
      <div style={{ ...layerStyles, width }}>
        <div style={getItemStyles(this.props)}>
          {children}
        </div>
      </div>
    );
  }
}

CustomDragLayer.propTypes = {
  item: PropTypes.object,
  itemType: PropTypes.string,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool.isRequired
};

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export default DragLayer(collect)(CustomDragLayer);



// WEBPACK FOOTER //
// ./src/browser/components/dragLayer.react.js